import { hasMixedCase, hasMinimumCharacters, hasNumber, hasSpecialChar, hasNoSpaces } from './checks'

export function validatePassword(password: string) {
  const checks = [
    hasMinimumCharacters(password),
    hasMixedCase(password),
    hasNumber(password),
    hasSpecialChar(password),
    hasNoSpaces(password),
  ]

  return checks.every(Boolean)
}
